/**
 * sl-728o.3.1: Input Source Session
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export function createInputSourceSession(t: I18n): TutorialSession {
  return {
    id: 'automation:inputSource',
    context: {
      targetAudience: 'technical',
      category: 'automation',
      tab: 'input',
    },
    steps: [
      {
        targetSelector: '[data-section="input-tables"]',
        title: t['com.streamlain.streamlain.coach.source-tables.title'](),
        content: t['com.streamlain.streamlain.coach.source-tables.content'](),
        animation: 'pulse',
      },
      {
        targetSelector: '[data-section="input-tables"]',
        title: t['com.streamlain.streamlain.coach.source-relations.title'](),
        content:
          t['com.streamlain.streamlain.coach.source-relations.content'](),
        animation: 'highlight',
      },
    ],
  };
}
